/*
 * Copyright (c) 2023 Bluemate B.V.
 */

export const invoiceFields = {
    order_id: 'Order ID',
    'calc:date': 'Tijdstip bestelling',
    'calc:date_only': 'Datum bestelling',
    'calc:send_date': 'Tijdstip verzending',
    'calc:send_date_only': 'Datum verzending',
    invoice_number: 'Factuurnummer',
    reference: 'Referentie',
    firstname: 'Voornaam',
    lastname: 'Achternaam',
    street: 'Straat',
    house_number: 'Huisnummer',
    house_number_suffix: 'Toevoeging',
    zip_code: 'Postcode',
    city: 'Stad',
    country: 'Land',
    language: 'Taal',
    address_supplement: 'Adres extra',
    delivery_street: 'Straat verzending',
    delivery_supplement: 'Adres extra verzending',
    delivery_house_number: 'Huisnummer verzending',
    delivery_house_number_suffix: 'Toevoeging verzending',
    delivery_zip_code: 'Postcode verzending',
    delivery_city: 'Stad verzending',
    delivery_country: 'Land verzending',
    phone_number: 'Telefoonnummer',
    company: 'Bedrijfsnaam',
    email: 'E-mailadres',
    vat_number: 'BTW-nummer',
    coc_number: 'KvK nummer',
    'calc:fulfilment': 'Logistiek'
};

export const orderFields = {
    item_id: 'Factuurregel ID',
    ean: 'EAN',
    title: 'Product',
    quantity_shipped: 'Aantal',
    'calc:price': 'Prijs',
    'calc:subtotal': 'Subtotaal excl. BTW',
    vat: 'BTW %',
    'calc:vat': 'BTW bedrag',
    'calc:total': 'Totaal incl. BTW',
    'calc:order_reference': 'Productreferentie',
    commission: 'Commissie'
};

export const defaultInvoiceFields: Array<string> = [
    'invoice_number',
    'calc:date',
    'calc:send_date',
    'order_id',
    'firstname',
    'lastname',
    'company',
    'street',
    'house_number',
    'house_number_suffix',
    'zip_code',
    'city',
    'country',
    'language',
    'address_supplement',
    'vat_number',
    'coc_number',
    'calc:fulfilment'
];
export const defaultOrderFields: Array<string> = [
    'ean',
    'quantity_shipped',
    'calc:price',
    'calc:subtotal',
    'vat',
    'calc:vat',
    'calc:total',
    'title'
];
